function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 203.92,
  x2: 234.948,
  y1: 267.401,
  y2: 213.658
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#c5baeb"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#e9e5f6"
}));

var _ref3 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "lg1"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  stopColor: "#ab2c37"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#ff7a85"
}));

var _ref4 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 290.32,
  x2: 301.603,
  xlinkHref: "#lg1",
  y1: 326.087,
  y2: 306.545
});

var _ref5 = /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_3_",
  gradientUnits: "userSpaceOnUse",
  x1: 287.726,
  x2: 305.854,
  xlinkHref: "#lg1",
  y1: 194.16,
  y2: 162.76
});

var _ref6 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m415.562 29.182-45.277-26.141c-5.19-4.023-12.401-4.215-20.378.39l-235.1 136.293c-15.805 9.125-28.619 33.607-28.619 54.681v228.107c0 12.123 4.245 20.467 10.856 23.64l47.838 27.711 40.473-15.693v26.377l47.287 27.453z",
  fill: "url(#SVGID_1_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m397.194 30.884-235.1 136.293c-15.805 9.125-28.618 33.607-28.618 54.681v228.107c0 21.074 12.813 30.761 28.618 21.636l70.548-40.731v81.13l98.475-137.985 66.077-38.708c15.805-9.125 28.618-33.607 28.618-54.681v-228.107c0-21.075-12.813-30.761-28.618-21.635z",
  fill: "#d7d1eb"
}), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "m315.629 294.122.001-.003-16.399-9.452-.001.002c-4.755-2.52-10.863-2.161-17.527 1.687-15.162 8.754-27.453 32.238-27.453 52.454 0 11.114 3.72 18.916 9.585 22.243l-.004.009 15.359 8.871.011-.024c4.838 2.892 11.184 2.683 18.139-1.333 15.162-8.754 27.453-32.238 27.453-52.454.002-10.848-3.54-18.544-9.164-22z",
  fill: "url(#SVGID_2_)"
}), /*#__PURE__*/React.createElement("ellipse", {
  cx: 297.342,
  cy: 331.973,
  fill: "#ff4757",
  rx: 42.145,
  ry: 23.843,
  transform: "matrix(.392 -.92 .92 .392 -124.55 475.589)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m320.9 141.59-14.778-8.206c-6.085-3.515-21.298-2.846-28.253 1.169-14.614 8.437-29.58 22.542-29.58 39.417l5.963 79.883c0 7.326 3.623 13.39 8.879 17.066l-.001.003.021.012c1.212.846 2.506 1.571 3.867 2.148l14.195 7.984.931-3.985c2.615-.343 5.24-1.195 7.751-2.645 14.614-8.438 23.616-24.03 23.616-40.905v-78.395c0-2.541-.438-4.93-1.226-7.123z",
  fill: "url(#SVGID_3_)"
}), /*#__PURE__*/React.createElement("path", {
  d: "m293.506 143.221c13.906-8.029 36.779-3.848 36.779 12.209l-5.49 84.25c0 16.875-9.003 32.468-23.616 40.905-13.906 8.029-31.289-2.007-31.289-18.065l-6.716-80.977c0-16.874 15.718-29.885 30.332-38.322z",
  fill: "#ff4757"
})));

var SvgNoData = function SvgNoData(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgNoData, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/no-data.905df2f0.svg";
export { ForwardRef as ReactComponent };